import React from 'react';

const DoctorSeal = ({ doctorName, registrationNumber }) => {
  // Generate a text-based seal matching the reference image style
  const doctorFullName = (doctorName || 'DR. DOCTOR NAME').toUpperCase();
  const regNo = (registrationNumber || 'REGD NO. XXXXXX').toUpperCase();
  
  // If registration number doesn't start with "REGD NO", add it
  const formattedRegNo = regNo.startsWith('REGD NO') ? regNo : `REGD NO. ${regNo}`;

  return (
    <div className="inline-block text-center py-3 px-4">
      <div className="space-y-1" style={{ 
        color: '#5B21B6', 
        fontFamily: 'system-ui, sans-serif',
        fontWeight: 'bold',
        fontSize: '14px',
        letterSpacing: '0.5px',
        textShadow: '0 0 1px rgba(91, 33, 182, 0.3)'
      }}>
        <div className="text-lg">{doctorFullName}</div>
        <div className="text-sm">M.B.B.S. GENERAL MEDICINE</div>
        <div className="text-sm">{formattedRegNo}</div>
      </div>
    </div>
  );
};

export default DoctorSeal;
